import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { themes, type Theme, type ThemesType } from "styles/theme";

import {
  Dispatch,
  SetStateAction,
  ReactNode,
  createContext,
  useState,
  useMemo,
} from "react";

interface Context {
  theme?: Theme;
  activeKey?: string;
  setTheme?: Dispatch<SetStateAction<ThemesType>>;
  sideMenuOpen?: boolean;
  setSideMenuOpen?: Dispatch<SetStateAction<boolean>>;
}

export const ThemeContext = createContext<Context>({});

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const [theme, setTheme] = useState<ThemesType>("light");
  const [sideMenuOpen, setSideMenuOpen] = useState<boolean>(false);

  const context = useMemo(
    () => ({
      theme: themes[theme],
      activeKey: theme as string,
      setTheme,
      sideMenuOpen,
      setSideMenuOpen,
    }),
    [theme, setTheme, sideMenuOpen, setSideMenuOpen]
  );

  return (
    <ThemeContext.Provider value={context}>
      <StyledThemeProvider theme={context.theme}>
        {children}
      </StyledThemeProvider>
    </ThemeContext.Provider>
  );
};
